import * as React from "react"
import Svg, { Path } from "react-native-svg"

// * Converted svg to component using https://react-svgr.com/playground/?native=true
const Arrows = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
    <Path d="M9 17.586V3H7v14.586l-2.293-2.293-1.414 1.414L8 21.414l4.707-4.707-1.414-1.414L9 17.586zM20.707 7.293 16 2.586l-4.707 4.707 1.414 1.414L15 6.414V21h2V6.414l2.293 2.293 1.414-1.414z" />
  </Svg>
)
export default Arrows
